import { ModalCustom } from "components/ModalCustom";
import { Body, TextoContainer } from "./style";
import { Informacao } from "components/Informacao";

interface IModalEditarServicoProps {
    show: boolean;
    handleClose: () => void;
    onConfirm: () => void;
}

export function ModalConfirmarAlterarEtapas({
    show,
    handleClose,
    onConfirm,
}: IModalEditarServicoProps) {

    const mensagem = "Esta ação afetará todos os despachantes e processos vinculados a este serviço, mantendo apenas as informações já cadastradas em custo e valor."

    return (
        <ModalCustom
            show={show}
            handleClose={handleClose}
            title="Alterar etapa"
            centered
            footer
            footerConfirmButton
            confirmButtonText="Salvar"
            onConfirm={onConfirm}
            size={"lg"}
        >
            <Body>
                <TextoContainer>
                    Deseja salvar as alterações realizadas nas etapas deste serviço?
                </TextoContainer>
                <Informacao
                    mensagem={mensagem}
                    type="atencao"
                />
            </Body>
        </ModalCustom>
    );
}